var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "artwork-size" },
    [
      _c(
        "tab-heading",
        _vm._g({ attrs: { "is-prev-disabled": true } }, _vm.$listeners),
        [
          _c("h2", { staticClass: "text-center" }, [_vm._v("Artwork Size")]),
          _c("p", { staticClass: "lead text-center mb-0" }, [
            _vm._v("Enter the size of the item you would like to frame:"),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "text-center my-4" },
        [
          _c("b-form-radio-group", {
            attrs: {
              options: _vm.sizeTypeOptions,
              buttons: "",
              "button-variant": "brand",
              size: "lg",
            },
            on: { change: _vm.onSizeTypeChange },
            model: {
              value: _vm.sizeType,
              callback: function ($$v) {
                _vm.sizeType = $$v
              },
              expression: "sizeType",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.sizeType == "bespoke",
              expression: 'sizeType == "bespoke"',
            },
          ],
          staticClass: "mb-5",
          attrs: { id: "bespoke-size-inputs" },
        },
        [
          _c(
            "b-row",
            { staticClass: "mb-3", attrs: { "align-h": "center" } },
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { md: "8" } },
                [
                  _c("unit-selector", {
                    model: {
                      value: _vm.displayUnit,
                      callback: function ($$v) {
                        _vm.displayUnit = $$v
                      },
                      expression: "displayUnit",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            { attrs: { "align-h": "center" } },
            [
              _c(
                "b-col",
                { attrs: { xl: "10" } },
                [
                  _c("size-input", {
                    attrs: {
                      unit: _vm.displayUnit,
                      size: "lg",
                      valid: _vm.areDimensionsValid,
                    },
                    model: {
                      value: _vm.artworkSize,
                      callback: function ($$v) {
                        _vm.artworkSize = $$v
                      },
                      expression: "artworkSize",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.sizeType == "standard",
              expression: 'sizeType == "standard"',
            },
          ],
          staticClass: "mb-4",
          attrs: { id: "standard-size-inputs" },
        },
        [
          _c(
            "b-row",
            { attrs: { "align-h": "center" } },
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("standard-size-selector", {
                    model: {
                      value: _vm.artworkSize,
                      callback: function ($$v) {
                        _vm.artworkSize = $$v
                      },
                      expression: "artworkSize",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-alert",
        { attrs: { variant: "danger", show: _vm.problems.length > 0 } },
        _vm._l(_vm.problems, function (problem, idx) {
          return _c("p", { key: idx, staticClass: "text-center mb-0" }, [
            _vm._v(_vm._s(problem)),
          ])
        }),
        0
      ),
      _c(
        "b-alert",
        { attrs: { variant: "warning", show: _vm.warnings.length > 0 } },
        _vm._l(_vm.warnings, function (warning, idx) {
          return _c("p", { key: idx, staticClass: "text-center mb-0" }, [
            _vm._v(_vm._s(warning)),
          ])
        }),
        0
      ),
      _c(
        "b-row",
        { staticClass: "my-4", attrs: { "align-h": "center" } },
        [
          _c("b-col", { staticClass: "pl-4 text-center", attrs: { md: "8" } }, [
            _c("p", { staticClass: "lead m-3" }, [
              _c("strong", [_vm._v("Size Guidance:")]),
            ]),
            _c("p", [
              _c("ul", { staticClass: "list-unstyled" }, [
                _c("li", { staticClass: "mb-2" }, [
                  _vm._v(
                    "The size you enter is the size of the artwork, photograph or item you wish to frame."
                  ),
                ]),
                _c("li", { staticClass: "mb-2" }, [
                  _vm._v(
                    "If you are adding a mount, the frame size will be increased to accommodate the mount."
                  ),
                ]),
                _c("li", { staticClass: "mb-2" }, [
                  _vm._v(
                    "The visible area of the artwork will be slightly less than the size you enter, due to the way frames and mounts are constructed."
                  ),
                ]),
              ]),
            ]),
            _c("p", { staticClass: "lead mb-3" }, [
              _c("strong", [_vm._v("Unsure what size to enter?")]),
            ]),
            _c("p", { staticClass: "lead" }, [
              _vm._v("View our "),
              _c(
                "a",
                { attrs: { href: "/guide-to-picture-frame-measurements" } },
                [_vm._v("Picture Frame Measurements Guide")]
              ),
              _vm._v("."),
            ]),
            _c("p", { staticClass: "lead m-3" }, [
              _c("strong", [_vm._v("Need a different measurement?")]),
            ]),
            _c("p", [
              _vm._v(
                "We can make frames measuring off a different dimension if required, such as:"
              ),
              _c("ul", { staticClass: "list-unstyled mt-2" }, [
                _c("li", [_vm._v("External size of frame")]),
                _c("li", [_vm._v("Internal size of frame (the rebate size)")]),
                _c("li", [_vm._v("Exact size of mount window")]),
              ]),
              _vm._v("Please "),
              _c("a", { attrs: { href: "/contact" } }, [_vm._v("contact us")]),
              _vm._v(" to discuss your requirements."),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }